import { render, staticRenderFns } from "./ApplicationIdentityCheckModal.vue?vue&type=template&id=765b7c9f&scoped=true"
import script from "./ApplicationIdentityCheckModal.vue?vue&type=script&lang=js"
export * from "./ApplicationIdentityCheckModal.vue?vue&type=script&lang=js"
import style0 from "./ApplicationIdentityCheckModal.vue?vue&type=style&index=0&id=765b7c9f&lang=scss"
import style1 from "./ApplicationIdentityCheckModal.vue?vue&type=style&index=1&id=765b7c9f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b7c9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('765b7c9f')) {
      api.createRecord('765b7c9f', component.options)
    } else {
      api.reload('765b7c9f', component.options)
    }
    module.hot.accept("./ApplicationIdentityCheckModal.vue?vue&type=template&id=765b7c9f&scoped=true", function () {
      api.rerender('765b7c9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/develop-manage/components/Modal/ApplicationIdentityCheckModal.vue"
export default component.exports